import React from 'react'
import { useSelector } from 'react-redux'
import { NodeContentProps } from '../../types'
import FormulaSelect from '../../../../../../../../features/formulas/components/FormulaSelect'
import { contextCompanyIdSelector } from '../../../../../../../../redux/context/company/selectors'

const FormulaNodeContent: React.FC<NodeContentProps> = ({ node, context, onUpdateValue }) => {
  const companyId = useSelector(contextCompanyIdSelector)

  // Jos kategorioiden kontekstissa ei ole yritystä käytetään sovelluksen konteksti yritystä
  if (!context.company) {
    return (
      <FormulaSelect
        mode="multiple"
        style={{ width: 500 }}
        value={node.value}
        companyId={companyId}
        onChange={value => onUpdateValue(node.id, { value })}
        data-cy={`formula-select-${node.id}`}
      />
    )
  }

  return (
    <FormulaSelect
      mode="multiple"
      style={{ width: 500 }}
      value={node.value}
      companyId={context.company}
      onChange={value => onUpdateValue(node.id, { value })}
      data-cy={`formula-select-${node.id}`}
    />
  )
}

export default FormulaNodeContent
